import { request } from '../axios/request';

import {
  FETCH_CANCELLATION_REASONS_PENDING__ORDER_CANCELLATION,
  FETCH_CANCELLATION_REASONS_FULFILLED__ORDER_CANCELLATION,
  FETCH_ORDER_REFUND_PENDING__ORDER_CANCELLATION,
  FETCH_ORDER_REFUND_REJECTED__ORDER_CANCELLATION,
  FETCH_ORDER_REFUND_FULFILLED__ORDER_CANCELLATION,
  SET_REFUNDED_ORDER_ITEMS__ORDER_CANCELLATION,
} from '../constants/orderCancellation';

const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

export const setCancelerOrderItems = (
  order,
  orderItems,
  refundInvoiceNumber
) => ({
  type: SET_REFUNDED_ORDER_ITEMS__ORDER_CANCELLATION,
  response: {
    order,
    orderItems,
    refundInvoiceNumber,
  },
});

const pending = () => ({
  type: FETCH_ORDER_REFUND_PENDING__ORDER_CANCELLATION,
});

const cancellationReasonsPending = () => ({
  type: FETCH_CANCELLATION_REASONS_PENDING__ORDER_CANCELLATION,
});

const fulfilled = (response) => ({
  type: FETCH_ORDER_REFUND_FULFILLED__ORDER_CANCELLATION,
  response: response,
});

const cancellationReasonsFulfilled = (response) => ({
  type: FETCH_CANCELLATION_REASONS_FULFILLED__ORDER_CANCELLATION,
  response: response,
});

const rejected = (error) => ({
  type: FETCH_ORDER_REFUND_REJECTED__ORDER_CANCELLATION,
  error: error,
});

export const fetchCancellationReasons = () => (dispatch) => {
  dispatch(cancellationReasonsPending());

  request({
    method: 'get',
    url: `${$U.CANCELLATION_REASONS}?cancellation_type=cancel`,
  })
    .then((response) => {
      dispatch(cancellationReasonsFulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};

export const refundOrder = (data) => (dispatch) => {
  dispatch(pending());

  request({
    method: 'post',
    url: `${$U.ORDER_CANCEL}${data.order}`,
    data: data,
  })
    .then((response) => {
      dispatch(fulfilled(response.data));
    })
    .catch((error) => {
      dispatch(rejected(error));
    });
};



// WEBPACK FOOTER //
// ./src/actions/orderCancellation.js